import { snakeCase } from "lodash-es";
const escapeRegExp = (text) => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
function mapBy(key, arr) {
  return arr.reduce((acc, val) => (acc[val[key]] = val) && acc, {});
}
const snakedKeysCache = /* @__PURE__ */ Object.create(null);
function getSnakedKeyFactory(staticPart, interceptor) {
  staticPart = snakeCaseKeepDots(staticPart);
  if (!snakedKeysCache[staticPart]) {
    snakedKeysCache[staticPart] = /* @__PURE__ */ Object.create(null);
  }
  const staticPartsCache = snakedKeysCache[staticPart];
  return (...dynamicParts) => {
    if (interceptor) {
      dynamicParts = interceptor(dynamicParts);
    }
    const dynamicPartHash = dynamicParts.toString();
    if (!staticPartsCache[dynamicPartHash]) {
      dynamicParts = dynamicParts.filter((part) => part !== void 0);
      staticPartsCache[dynamicPartHash] = staticPart + "." + dynamicParts.map((part) => snakeCaseKeepDots(part)).join(".");
    }
    return staticPartsCache[dynamicPartHash];
  };
}
function snakeCaseKeepDots(input) {
  return input.split(".").map((part) => snakeCase(part)).join(".");
}
function flatten(source, delimiter = ".", isValue, skip) {
  const result = /* @__PURE__ */ Object.create(null);
  (function flat(obj, stack) {
    Object.keys(obj).forEach(function(key) {
      const path = stack.concat([key]);
      const val = obj[key];
      if (skip && skip(key, val)) {
        return;
      }
      if (typeof val === "object" && (!isValue || !isValue(val, key))) {
        flat(val, path);
      } else {
        result[path.join(delimiter)] = val;
      }
    });
  })(source, []);
  return result;
}
const byteUnits = ["B", "kB", "MB", "GB", "TB"];
function byteConvert(num, currentUnit = "B") {
  const unitIndex = byteUnits.indexOf(currentUnit);
  if (unitIndex === -1) {
    throw new Error(
      'Unknown byte unit: "' + currentUnit + '" expects one of: ' + byteUnits.join(", ")
    );
  }
  if (num >= 1024) {
    const higherUnit = byteUnits[unitIndex + 1];
    if (!higherUnit) {
      return num + currentUnit;
    }
    return byteConvert(Math.floor(num / 1024), higherUnit);
  } else if (num < 1) {
    const lowerUnit = byteUnits[unitIndex - 1];
    if (!lowerUnit) {
      return num + currentUnit;
    }
    return byteConvert(Math.floor(num * 1024), lowerUnit);
  }
  return num + currentUnit;
}
const customValuesCompare = (values, A, B, dir) => {
  const position = values.indexOf(A);
  const position2 = values.indexOf(B);
  if (position2 !== -1 && position !== -1) {
    return (position < position2 ? -1 : 1) * dir;
  }
  if (position !== -1) {
    return 1 * dir;
  }
  if (position2 !== -1) {
    return -1 * dir;
  }
  return dir;
};
function jsonFilter(value) {
  return JSON.stringify(value, null, 2);
}
function cardHash(value) {
  if (!value) {
    return value;
  }
  value = value.replace(/\s/g, "");
  return value.substr(0, 4) + " **** **** " + value.substr(-4);
}
function assign(...args) {
  return Object.assign.apply(Object, [{}, ...args]);
}
function evaluate(attribute) {
  if (typeof attribute === "function") {
    return attribute();
  }
  return attribute;
}
const emailPattern = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,63}$/i;
const webPattern = /^(\*\.)*?([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+)$/i;
export {
  assign,
  byteConvert,
  byteUnits,
  cardHash,
  customValuesCompare,
  emailPattern,
  escapeRegExp,
  evaluate,
  flatten,
  getSnakedKeyFactory,
  jsonFilter,
  mapBy,
  snakeCaseKeepDots,
  webPattern
};
//# sourceMappingURL=index.es.js.map
